import {Alert, Paper} from "@mui/material";
import CompatibilityViolation from '../types/CompatibilityViolation'

interface IncompatibilityListProps {
    violation: CompatibilityViolation
}

const IncompatibilityList = ({violation} : IncompatibilityListProps) => {
    return (
    <Paper elevation={1} className="m-2">The schema on the right is not {violation.type.toLowerCase()}-compatible with the schema on the left because:
          {violation.incompatibilities?.map(i => <Alert severity="error" className="m-1">{i.description}</Alert>)}
        </Paper>
    )
}

export default IncompatibilityList;